module.exports = __webpack_public_path__ + "static/media/adobe-xd.162b30c7.svg";